import cn from 'classnames';
import type { ProgramTimelineContentObject } from 'models';
import { useTranslation } from 'react-i18next';
import { Flex, Text } from 'ui';
import variables from 'common/styles/variables.json';
import { useBodyTitle } from './hooks';

type P = {
  last: boolean;
  post: ProgramTimelineContentObject;
  type?: 'checked' | 'selected' | 'unchecked';
};

const ProgramTopicPostBody = ({ last, post, type }: P) => {
  const { t } = useTranslation();

  const preview = useBodyTitle(post);

  return (
    <Flex className={cn('program-topic-post-body', { 'program-topic-post-body--last': last })} vertical>
      {preview ? (
        <Text size="large" style={type === 'selected' ? { color: variables.brandColor.value } : {}}>
          {preview}
        </Text>
      ) : null}
      <Text size="small">
        <Text size="small">Posted</Text> • {t('dateFormats.shortMonthDayYear', { date: post.publishAt })}
      </Text>
    </Flex>
  );
};

export default ProgramTopicPostBody;
